import styled from "styled-components";
//
export const Wrapper = styled.div`
  min-width: 100%;
  min-height: 100%;
  margin: 0;
  padding: 1.25rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "SF UI Display", sans-serif;
  background-color: #f8f8f8;
  position: relative;
`;
//
export const FormWrapper = styled.div`
  width: 100%;
  flex-grow: 1;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
//
export const Heading = styled.div`
  font-size: 1.375rem;
  font-weight: bold;
  text-align: center;
  color: #000;
  letter-spacing: 0.22px;
  margin-bottom: 4px;
`;
//
export const SubHeading = styled.div`
  font-size: 0.875rem;
  line-height: 1.25;
  text-align: center;
  margin-top: 0.6rem;
  color: rgba(32, 31, 30, 0.85);
`;
//
export const MessageBox = styled.div`
  margin-top: -1.5rem;
  margin-bottom: 1.875rem;

  svg {
    display: none;
  }
`;
//
export const MessageBoxWarning = styled(MessageBox)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 1.242rem;
  border-radius: 5px;
  background-color: #f8eccf;
  margin-top: 1.875rem;
  padding: 1rem;

  .icon-wrapper {
    margin-right: 1rem;

    svg {
      display: block;
    }
  }
`;
//
export const MessageBoxSuccess = styled(MessageBoxWarning)`
`;
//
export const Message = styled.div`
  font-size: 0.875rem;
  text-align: center;
  color: rgba(32, 31, 30, 0.85);
  line-height: 20px;
  
  strong, b {
    font-weight: bold;
  }
  
  span {
    max-height: 20px;
  }
  
  .ellipsis {
    font-weight: bold;
    text-overflow: ellipsis;
    max-width: 360px;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    vertical-align: bottom;
  }
`;
//
export const Form = styled.form`
  margin-top: 1.875rem;
  width: 100%;
  max-width: 340px;
  position: relative;
`;
//
export const InputWrapper = styled.div`
  width: 100%;
  position: relative;
  margin: 0.75rem auto;

  &:first-of-type {
    margin-top: 0;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  .edit-email-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
`;
//
export const Input = styled.input`
  width: 100%;
  height: 28px;
  box-sizing: border-box;
  padding: 0.375rem 0.625rem;
  border-radius: 5px;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.13);
  border: solid 1px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  font-family: inherit !important;
  font-size: 0.875rem;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
  outline: none;

  &:disabled {
    opacity: 0.5;
    box-shadow: 0 0.5px 0 0 rgba(0, 0, 0, 0.06);
    border: solid 0.5px rgba(0, 0, 0, 0.08);
    background-color: #fff;
  }

  &[type="email"],
  &:read-only {
    padding-right: 35px !important;
  }

  &[type="password"] {
    padding-right: 35px !important;
  }
`;
//
export const SigninOptionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.813rem;
  margin: 1rem auto;
  margin-bottom: -1rem;

  label {
    margin-right: 0.625rem;
  }

  button {
    margin-left: 0.625rem;
  }
`;
//
export const ButtonWrapper = styled.div`
  width: 100%;
  margin-top: 2rem;
  position: relative;
`;
//
export const Button = styled.button`
  font-family: inherit !important;
  width: 100%;
  height: 28px;
  padding: 0.375rem 0.625rem;
  border-radius: 5px;
  box-shadow: 0 0.5px 1px 0 rgba(0, 0, 0, 0.28);
  background-color: #17bed0;
  border: none;
  font-size: 0.813rem;
  font-weight: normal;
  text-align: center;
  color: #fff;
  cursor: pointer;

  &:disabled {
    border: solid 0.5px rgba(0, 0, 0, 0.02);
    background-color: #fff;
    color: rgba(0, 0, 0, 0.25);
    cursor: auto;
  }
`;
//
export const ButtonLink = styled.button`
  font-size: ${({fontSize}) => fontSize ? fontSize : "0.813rem"};
  font-family: inherit !important;
  background-color: transparent;
  border: none;
  color: ${({color}) => color ? color : "#17bed0"};
  padding: 0;
  cursor: pointer;
`;
//
export const FooterLink = styled(ButtonLink)`
  font-size: 0.875rem;
  margin-left: 0.25rem;
`
//
export const SocialButtonWrapper = styled.div`
  width: 100%;
  max-width: 340px;
`;
//
export const SocialButton = styled.div`
  width: 108px;
  height: 28px;
  padding: 0.375rem;
  box-sizing: border-box;
  border-radius: 5px;
  box-shadow: 0 0.5px 1px 0 rgba(0, 0, 0, 0.15);
  border: solid 1px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ContinueWith = styled.div`
  font-size: 0.75rem;
  text-align: center;
  color: #a19f9d;
  margin: 0.625rem auto;
`;

export const Footer = styled.footer`
  width: 100%;
  margin-top: 0.625rem;
  text-align: center;
`;